import { DetailsHeader, NotFoundMessage, Segments } from "components";
import { RouteNames } from "enums";
import { Route, Routes } from "react-router";
import OverviewReport from "./Overview/OverviewReport";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { FeatureFlags } from "featureFlags";
import { ReportUnavailable } from "components/reportUnavailable/ReportUnavailable";

const pages = [{ to: "", label: "Overview" }];

export const DashboardReport = () => {
  const isDashboardReportsEnabled = !!useFeatureFlag(FeatureFlags.DashboardReports);

  if (!isDashboardReportsEnabled) {
    return <ReportUnavailable />;
  }

  return (
    <div className="root nested-content">
      <DetailsHeader title="Dashboard" showReportLastUpdated />
      <Segments to={`/${RouteNames.reporting}/${RouteNames.overview}`}>
        {pages.map((page, i) => (
          <Segments.Segment key={i} {...page} />
        ))}
      </Segments>
      <Routes>
        <Route path="" element={<OverviewReport />} />
        <Route path="*" element={<NotFoundMessage />} />
      </Routes>
    </div>
  );
};
